/**
 * Create a gutter that displays the page numbers for the document.
 * @module pageNumbersGutter
 * @category CodeMirror
 */
import { Line, RangeSet, RangeSetBuilder, StateField, Text } from "@codemirror/state";

import { gutter, GutterMarker } from "@codemirror/view";
import { controlCharsObject } from "../controlChars";

export interface GutterState {
  line: Line;
  pageIdx: number;
  type?: "page" | "row" | "col";
}

function createGutterState(doc: Text): GutterState[] {
  const lines = doc.iterLines();
  let pageIdx = 1;
  let lineIdx = 1;
  // line 0 is the first page.
  const gutterState: GutterState[] = [{ line: doc.line(1), pageIdx }];

  // base 1 for pages.
  for (const line of lines) {
    if (line === controlCharsObject["==="].controlChar) {
      pageIdx++;
      gutterState.push({ line: doc.line(lineIdx), pageIdx, type: "page" });
    }

    if (line === controlCharsObject["---"].controlChar) {
      gutterState.push({ line: doc.line(lineIdx), pageIdx, type: "row" });
    }

    lineIdx++;
  }
  return gutterState;
}

export const pageNumbersGutterState: StateField<GutterState[]> = StateField.define({
  create(state): GutterState[] {
    return createGutterState(state.doc);
  },
  update(_gutterState, tr): GutterState[] {
    return createGutterState(tr.newDoc);
  },
});

class pageNumbersGutterMarker extends GutterMarker {
  constructor(pageIdx: number) {
    super();
    this.pageIdx = pageIdx;
    this.elementClass = "qp-gutter-pageNumber";
  }

  pageIdx: number;
  toDOM() {
    const el = document.createElement("div");
    const number = document.createTextNode(this.pageIdx.toString());
    return el.appendChild(number);
  }
}

// class lineGutterMarker extends GutterMarker {
//   constructor() {
//     super();
//     this.elementClass = "qp-line-gutter-marker";
//   }

//   toDOM() {
//     const el = document.createElement("div");
//     el.className = "qp-line-marker";
//     return el;
//   }
// }

// class rowGutterMarker extends GutterMarker {
//   constructor() {
//     super();
//     this.elementClass = "cm-qp-row-marker";
//   }

//   toDOM() {
//     const el = document.createElement("div");
//     el.ariaLabel = "row divider";
//     return el;
//   }
// }

// class colGutterMarker extends GutterMarker {
//   constructor() {
//     super();
//     this.elementClass = "cm-qp-col-marker";
//   }

//   toDOM() {
//     const el = document.createElement("div");
//     el.ariaLabel = "column divider";
//     return el;
//   }
// }

export const pageMarkerState = StateField.define<RangeSet<GutterMarker>>({
  create() {
    return RangeSet.empty;
  },
  update(_set, transaction) {
    const pages = transaction.state.field(pageNumbersGutterState);
    const newSet = new RangeSetBuilder<GutterMarker>();

    if (Array.isArray(pages)) {
      pages.forEach(({ line, pageIdx, type }) => {
        let marker;

        // if (type === "col") {
        //   marker = new colGutterMarker();
        // }

        // if (type === "row") {
        //   marker = new rowGutterMarker();
        // }

        if (type === "page") {
          marker = new pageNumbersGutterMarker(pageIdx);
        }
        if (marker) {
          newSet.add(
            line.from,
            line.from,
            marker,
          );
        }
      });
    }
    return newSet.finish();
  },
});

export const pageNumbersGutter = [
  [pageMarkerState, pageNumbersGutterState],
  gutter({
    class: "cm-page-numbers-gutter-gutter",
    renderEmptyElements: true,
    markers: v => {
      return v.state.field(pageMarkerState);
    },

  }),
  // EditorView.baseTheme({
  //     ".cm-qp-pageNumber": {
  //         width: "1rem",
  //         cursor: "default",
  //         "text-align": "center",
  //         border: "1px solid #d5d5d5",

  //     },
  //     ".cm-qp-pageNumber .cm-activeLineGutter": {
  //         "background-color": "red",
  //     },
  // }),
];


